import { IconAlertCircleFilled, IconCircleCheckFilled, IconCircleXFilled } from '@tabler/icons-react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { FC } from 'react'
import { Renderable, ToastPosition, ToastType } from 'react-hot-toast'

interface ToastBarProps {
  message: Renderable
  duration?: number
  type: ToastType
  position: ToastPosition
  icon?: Renderable
}

const ToastBar: FC<ToastBarProps> = (props) => {
  const { message, type, icon, position } = props
  const backgroundColor = {
    success: 'bg-green-400',
    error: 'bg-red-500',
    loading: 'bg-white',
    blank: 'bg-white',
    custom: 'bg-white'
  }[type]

  const textColor = {
    success: 'text-white',
    error: 'text-white',
    loading: '',
    blank: '',
    custom: ''
  }[type]

  const iconElement = icon ? (
    icon
  ) : type === 'success' ? (
    <IconCircleCheckFilled className="text-white" />
  ) : type === 'error' ? (
    <IconCircleXFilled className="text-white" />
  ) : (
    <IconAlertCircleFilled className="text-yellow-500" />
  )

  const initial = {
    'bottom-right': { x: '100%' },
    'bottom-center': { y: '100%' },
    'bottom-left': { x: '-100%' },
    'top-right': { x: '100%' },
    'top-center': { y: '-100%' },
    'top-left': { x: '-100%' }
  }[position]

  const animation = {
    'bottom-right': { x: 0 },
    'bottom-center': { y: 0 },
    'bottom-left': { x: 0 },
    'top-right': { x: 0 },
    'top-center': { y: 0 },
    'top-left': { x: 0 }
  }[position]

  const exit = {
    'bottom-right': { x: '100%' },
    'bottom-center': { y: '130%' },
    'bottom-left': { x: '-100%' },
    'top-right': { x: '100%' },
    'top-center': { y: '-100%' },
    'top-left': { x: '-100%' }
  }[position]

  return (
    <motion.div className="z-10000000" initial={initial} animate={animation} exit={exit}>
      <div className={classNames(backgroundColor, 'h-16 px-4 gap-3 text-lg flex items-center justify-center rounded-xl shadow-primary', textColor)}>
        <motion.div initial={{ scale: 0, rotate: 0 }} animate={{ scale: 1, rotate: 360 }} transition={{ duration: 0.5 }}>
          {iconElement}
        </motion.div>
        {message}
      </div>
    </motion.div>
  )
}

export default ToastBar
